import {
  getLifeAreaDocById,
  updateLifeArea,
} from 'shared/services/backend-api';
import { Task } from 'shared/types/task';

export const updateLinkedLifeArea = async (
  taskPairs: Array<{ oldTask: Task; newTask: Task }>,
) => {
  if (!taskPairs.length) {
    return;
  }

  // Group task pairs by lifeAreaId, only include main tasks (no parentIds)
  const lifeAreaGroups = new Map<
    string,
    Array<{ oldTask: Task; newTask: Task }>
  >();

  taskPairs.forEach(({ oldTask, newTask }) => {
    if (!oldTask.lifeAreaId || oldTask.parentIds?.length) {
      return;
    }

    const lifeAreaId = oldTask.lifeAreaId;
    const existing = lifeAreaGroups.get(lifeAreaId) ?? [];
    lifeAreaGroups.set(lifeAreaId, [...existing, { oldTask, newTask }]);
  });

  // Update each life area once with all relevant tasks
  await Promise.all(
    Array.from(lifeAreaGroups.entries()).map(async ([lifeAreaId, pairs]) => {
      const lifeArea = await getLifeAreaDocById(lifeAreaId);
      if (!lifeArea || !lifeArea.taskSorting?.length) {
        return;
      }

      const taskSorting = [...lifeArea.taskSorting];
      // Sort pairs by their position in taskSorting (descending) to insert from end
      // This ensures indices remain correct when inserting multiple tasks
      const sortedPairs = pairs
        .map((pair) => ({
          ...pair,
          index: taskSorting.findIndex((id) => id === pair.oldTask.id),
        }))
        .filter((pair) => pair.index >= 0)
        .sort((a, b) => b.index - a.index);

      sortedPairs.forEach(({ newTask, index }) => {
        taskSorting.splice(index, 0, newTask.id);
      });

      updateLifeArea({ id: lifeArea.id, taskSorting });
    }),
  );
};
